import { Registration } from '@/components/Registration';
import { Section } from '@/components/Section';
import { staticProps } from '@/util/staticProps';
import { NextSeo } from 'next-seo';
import { PageRefType } from '@/resource/settings';

type Props = {
  rulesPage: PageRefType | null;
};

export default function Register({ rulesPage }: Props) {
  return (
    <>
      <NextSeo title="Registreren" />
      <Section>
        <Registration rulesPage={rulesPage} />
      </Section>
    </>
  );
}

export const getStaticProps = staticProps.resolve(async (ctx, settings) => {
  return {
    props: {
      rulesPage: settings.rules_page?.data || null,
    },
    revalidate: 10,
  };
});
